import { RateQuoteRequest, RateQuoteResponse } from '@/model/rate';

import { BaseHttpController } from './BaseHttpController';

const endpoint = 'quote';

export class QuoteController extends BaseHttpController {
  constructor() {
    super(endpoint);
  }

  async getRates(quoteRequest: RateQuoteRequest): Promise<RateQuoteResponse> {
    const response = await this.http.post<RateQuoteResponse>('', {
      quoteRequest,
    });
    return new RateQuoteResponse(response.data);
  }
}
